// components/use-case-details/use-case-stats-banner.tsx
"use client";

import { ActivitySquare,Brain, Clock, FileCheck, Map } from 'lucide-react';
import React from 'react';

interface UseCaseStatsBannerProps {
  vertical: string;
  aiModels: string;
  implementationType: string;
  problemSolved: string;
  implementationTime: string;
  complexity: string;
}

// StatCard component for displaying individual stats
interface StatCardProps {
  title: string;
  value: string;
  icon: React.ReactNode;
}

const StatCard = ({ title, value, icon }: StatCardProps) => (
  <div className="p-3 rounded-lg flex flex-col">
    <div className="flex items-center mb-2">
      {icon}
      <h3 className="text-xs font-medium text-gray-400 ml-2">{title}</h3>
    </div>
    <p className="text-sm md:text-base font-bold text-white">{value}</p>
  </div>
);

export function UseCaseStatsBanner({
  vertical,
  aiModels,
  implementationType,
  problemSolved,
  implementationTime,
  complexity,
}: UseCaseStatsBannerProps) {
  return (
    <div className="stats-banner bg-gray-800 border-t border-b border-gray-700 py-6">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {/* Vertical */}
          <StatCard
            title="Vertical"
            value={vertical}
            icon={<Map className="text-yellow-500" />}
          />
          
          {/* AI Models */}
          <StatCard
            title="AI Models"
            value={aiModels}
            icon={<Brain className="text-teal-500" />}
          />
          
          {/* Implementation Type */}
          <StatCard
            title="Implementation"
            value={implementationType}
            icon={<FileCheck className="text-blue-400" />}
          />
          
          {/* Problem Solved */}
          {/* <StatCard
            title="Problem Solved"
            value={problemSolved}
            icon={<ScanSearch className="text-pink-400" />}
          />
           */}
          {/* Implementation Time */}
          <StatCard
            title="Implementation Time"
            value={implementationTime}
            icon={<Clock className="text-green-400" />}
          />
          
          {/* Complexity */}
          <StatCard
            title="Complexity"
            value={complexity}
            icon={<ActivitySquare className="text-purple-400" />}
          />
        </div>
      </div>
    </div>
  );
}


// "use client";
// // components/use-case-details/use-case-stats-banner.tsx
// interface UseCaseStatsBannerProps {
//   companySize: string;
//   companySizeDetail: string;
//   aiModels: string;
//   aiModelsDetail: string;
//   implementationTime: string;
//   implementationTimeDetail: string;
//   roiMetrics: string;
//   roiMetricsDetail: string;
//   backgroundVariant?: "default" | "teal" | "slate" | "dark";
// }

// export function UseCaseStatsBanner({
//   companySize,
//   companySizeDetail,
//   aiModels,
//   aiModelsDetail,
// implementationTime,
//   implementationTimeDetail,
//   roiMetrics,
//   roiMetricsDetail,
//   backgroundVariant = "default"
// }: UseCaseStatsBannerProps) {
//   // Background variants mapping
//   const bgClasses = {
//     default: "bg-gradient-to-r from-bg-dark to-bg-slate",
//     teal: "bg-bg-dark",
//     slate: "bg-bg-slate",
//     dark: "bg-black"
//   };

//   return (
//     <div className={`${bgClasses[backgroundVariant]} border-t border-b border-medium-gray`}>
//       <div className="container mx-auto px-4 py-8">
//         <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
//           <div className="bg-black/30 p-4 rounded-lg">
//             <h3 className="text-sm font-medium text-light-gray mb-1">COMPANY SIZE</h3>
//             <p className="text-xl font-display font-bold text-white">{companySize}</p>
//             <p className="text-sm text-light-gray">{companySizeDetail}</p>
//           </div>
          
//           <div className="bg-black/30 p-4 rounded-lg">
//             <h3 className="text-sm font-medium text-light-gray mb-1">AI MODELS</h3>
//             <p className="text-xl font-display font-bold text-white">{aiModels}</p>
//             <p className="text-sm text-light-gray">{aiModelsDetail}</p>
//           </div>
          
//           <div className="bg-black/30 p-4 rounded-lg">
//             <h3 className="text-sm font-medium text-light-gray mb-1">IMPLEMENTATION TIME</h3>
//             <p className="text-xl font-display font-bold text-white">{implementationTime}</p>
//             <p className="text-sm text-light-gray">{implementationTimeDetail}</p>
//           </div>
          
//           <div className="bg-black/30 p-4 rounded-lg">
//             <h3 className="text-sm font-medium text-light-gray mb-1">ROI METRICS</h3>
//             <p className="text-xl font-display font-bold text-teal">{roiMetrics}</p>
//             <p className="text-sm text-light-gray">{roiMetricsDetail}</p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }